<script setup>
import SideBar from "./SideBar.vue";
import startupsService from "@/services/ecosystem/startups.service";
import {ref, onMounted, provide, computed, watch} from "vue";
import StartupsTable from "./StartupsTable.vue";
import useStoreTrigger from "@/composables/useStoreTrigger";
import {useStore} from "vue2-helpers/vuex";

const store = useStore();
const storeTrigger = useStoreTrigger();

const numbers = ref(null);

watch(() => store.state.needUpdateStartups, value => {
    if (value) {
        getNumbers();
    }
});

onMounted(() => {
    getNumbers();
});

async function getNumbers() {
    numbers.value = null;
    const {data} = await startupsService.getMyStartupsNumbers();

    numbers.value = data;
}

function addStartup() {
    storeTrigger('setAddStartup');
}

provide('numbers', numbers);
provide('hasStartups', computed(() => !!numbers.value?.total));
</script>

<template>
    <div v-if="numbers !== null" class="mystartups-page dashboard-page">
        <SideBar
            @addStartup="addStartup"
            @inviteStartup="addStartup"
        />

        <main class="mystartups-page__main">
            <ul class="stat-overview">
                <li>Total Startups <big>{{numbers.total.toLocaleString()}}</big></li>
                <li>Submitted to Needs <big>{{numbers.submitted.toLocaleString()}}</big> </li>
                <li>Under Review <big>{{numbers.unreviewed.toLocaleString()}}</big></li>
                <li>Accepted <big>{{numbers.accepted.toLocaleString()}}</big></li>
                <li>Escalated <big>{{numbers.escalated.toLocaleString()}}</big></li>
            </ul>

            <StartupsTable
                @addStartup="addStartup"
            />
        </main>
    </div>
</template>

<style scoped>

</style>
